export const removePagination = (filters: { [key: string]: any }) => {
  const outFilters = { ...filters };
  delete outFilters.pageIndex;
  delete outFilters.pageSize;
  return outFilters;
};
